/* ============================================================
   ng-motion — shared scroll/reveal motion utility (Neurogan)

   Data-attribute API (opt-in per element):
     data-ng-reveal              fade + rise on enter
     data-ng-reveal-stagger      stagger direct children on enter
     data-ng-sequence            reveal children one-by-one (audit rows)
     data-ng-reveal-repeat       re-hide when scrolled out (replayable)
     data-ng-count               count-up a number when in view
       data-ng-count-to          target number (required)
       data-ng-count-prefix      text before the number   (optional)
       data-ng-count-suffix      text after the number    (optional, e.g. "+")
       data-ng-count-decimals    decimal places           (optional, default 0)
       data-ng-count-duration    ms                       (optional, default 1200)

   Content is visible by default. This script only HIDES elements
   (via the `.ng-armed` class) when it is running AND motion is
   allowed — then reveals them. If the script never runs, nothing is
   hidden. Authoring rule: put the FINAL formatted value in a
   data-ng-count element's text so it is correct with JS disabled.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canObserve = 'IntersectionObserver' in window;
  var enhance = !reduce && canObserve;

  function formatNum(n, el) {
    var dec = parseInt(el.getAttribute('data-ng-count-decimals') || '0', 10);
    return Number(n).toLocaleString(undefined, {
      minimumFractionDigits: dec,
      maximumFractionDigits: dec
    });
  }

  function runCount(el) {
    if (el.__ngCounted) return;
    el.__ngCounted = true;

    var target = parseFloat(el.getAttribute('data-ng-count-to'));
    if (isNaN(target)) return;

    var prefix = el.getAttribute('data-ng-count-prefix') || '';
    var suffix = el.getAttribute('data-ng-count-suffix') || '';

    if (!enhance) {
      el.textContent = prefix + formatNum(target, el) + suffix;
      return;
    }

    var dur = parseInt(el.getAttribute('data-ng-count-duration') || '1200', 10);
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = prefix + formatNum(Math.round(target * eased), el) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + formatNum(target, el) + suffix;
    }
    requestAnimationFrame(step);
  }

  function setStaggerIndex(el) {
    var kids = el.children;
    for (var i = 0; i < kids.length; i++) kids[i].style.setProperty('--ng-i', i);
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.92 && r.bottom > 0;
  }

  var REVEAL_SELECTOR = '[data-ng-reveal],[data-ng-reveal-stagger],[data-ng-sequence]';
  var revealEls = Array.prototype.slice.call(document.querySelectorAll(REVEAL_SELECTOR));
  var countEls = Array.prototype.slice.call(document.querySelectorAll('[data-ng-count]'));

  /* Reduced motion or no IntersectionObserver: leave everything visible,
     just finalize any count-up values. Never arm (never hide). */
  if (!enhance) {
    countEls.forEach(runCount);
    return;
  }

  /* Arm: hide now, reveal in-view items synchronously (no flash), observe the rest. */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (e.isIntersecting) {
        el.classList.add('ng-in');
        if (!el.hasAttribute('data-ng-reveal-repeat')) revealObs.unobserve(el);
      } else if (el.hasAttribute('data-ng-reveal-repeat')) {
        el.classList.remove('ng-in');
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  revealEls.forEach(function (el) {
    if (el.hasAttribute('data-ng-reveal-stagger') || el.hasAttribute('data-ng-sequence')) {
      setStaggerIndex(el);
    }
    el.classList.add('ng-armed');
    if (inView(el)) el.classList.add('ng-in');
    if (!el.classList.contains('ng-in') || el.hasAttribute('data-ng-reveal-repeat')) {
      revealObs.observe(el);
    }
  });

  var countObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { runCount(e.target); countObs.unobserve(e.target); }
    });
  }, { threshold: 0.4 });
  countEls.forEach(function (el) { countObs.observe(el); });
})();
